export default "__VITE_ASSET__BcXpvBgc__"